module.exports = __webpack_public_path__ + "static/media/icon_watch_inverse.7e0ef3f4.svg";